export const PORTRAIT_DEFAULT_LAYOUT_VIDEO_BOTTOM_PADDING = 800;
export const SQUARE_DEFAULT_LAYOUT_VIDEO_BOTTOM_PADDING = 320;
